<template>
  <section class="section pt-0" id="skills" ref="skills"> 
    <b-container class="skills-container" v-show="showCards">
      <div class="title-wrapper">
        <span>
          <h2 class="font-bad font-weight-bold text-center mb-0"> Skills </h2>
        </span>
      </div>
      <b-row class="skills-wrapper justify-content-center"
        >
        <b-col cols="12" sm="6" lg="4" class="card-container mb-4 mb-xl-0"
          v-for="card in cards"
          :key="card.id">
          <div class="card-item flip mx-auto" 
            id="frontend" 
            @mouseenter="frontActive = true"
            @mouseleave="frontActive = false">
            <div class="card-body">
              <div class="card-front bicolor" >
                <div class="icon-area">
                  <div class="circle-container">
                    <div class="circle d-flex align-items-center justify-content-center">
                      <i :class="card.icon"></i>
                    </div>
                  </div>
                </div>
                <h2 class="title">
                  {{card.title}}
                </h2>
              </div>
              <div class="card-back">
                <div class="radial-wrapper d-flex flex-wrap justify-content-around align-content-around">                
                  <radial-progress-bar 
                    v-for="el in card.backFace"
                    v-bind:key="el.id"
                    :diameter="100"
                    :completed-steps="frontActive ? el.completed : 0"
                    :start-color="startColor"
                    :stop-color="stopColor"
                    :total-steps="totalSteps"
                    :strokeWidth="strokeWidth"
                    :innerStrokeWidth="innerStrokeWidth">
                    <p>{{el.name}}</p>
                  </radial-progress-bar>
                </div>
              </div>
            </div>
          </div>   
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
  //import Vue from 'vue';
  import RadialProgressBar from 'vue-radial-progress'
  import { gsap } from "gsap";
  export default {
    components: { RadialProgressBar },
    props:{
      showCards:{
        type: Boolean,
        required: true
      }
    },
    mounted(){
    
    },
    data() {
      return {
        totalSteps: 10,
        startColor: '#F2C4CE',
        stopColor: '#F58F7C',
        innerStrokeColor: '#2C2B30',
        strokeWidth: 5,
        innerStrokeWidth: 5,

        frontActive: false,
        backActive: false,
        otherActive: false,

        cards: [
          {
            id: 'frontend',
            title: 'Frontend',
            backFace: [
              {
                id: 'htmlcss',
                name: 'HTML & CSS',
                completed: 8,
              },
              {
                id: 'js',
                name: 'JS',
                completed: 8,
              },
              {
                id: 'vue',
                name: 'Vue.js',
                completed: 9,
              },
              {
                id: 'vuex',
                name: 'Vuex',
                completed: 8,
              },
              {
                id: 'bootstrap',
                name: 'Bootstrap',
                completed: 10,
              },
              {
                id: 'vuetify',
                name: 'Vuetify',
                completed: 7,
              }
            ],
            icon: 'far fa-heart color-pink-accent'
          },
          {
            id: 'backend',
            title: 'Backend',
            backFace: [
              {
                id: 'csharp',
                name: 'C#',
                completed: 10,
              },
              {
                id: 'net',
                name: '.NET',
                completed: 8,
              },
              {
                id: 'php',
                name: 'PHP',
                completed: 6,
              },
            ],
            icon: 'fas fa-terminal color-gray-light'
          },
          {
            id: 'others',
            title: 'Others',
            backFace: [
              {
                id: 'pm',
                name: 'PM, Scrum',
                completed: 9,
              },
              {
                id: 'git',
                name: 'GIT',
                completed: 8,
              },
              {
                id: 'eng',
                name: 'English',
                completed: 9,
              },
              {
                id: 'firebase',
                name: 'Firebase',
                completed: 8,
              },
              {
                id: 'seo',
                name: 'SEO',
                completed: 8,
              },
            ],
            icon: 'far fa-star color-gray-light'
          }
        ],

        frontend: [
          {
            id: 'htmlcss',
            name: 'HTML & CSS',
            completed: 8,
          },
          {
            id: 'js',
            name: 'JS',
            completed: 8,
          },
          {
            id: 'vue',
            name: 'Vue.js',
            completed: 9,
          },
          {
            id: 'vuex',
            name: 'Vuex',
            completed: 8,
          },
          {
            id: 'bootstrap',
            name: 'Bootstrap',
            completed: 10,
          },
          {
            id: 'vuetify',
            name: 'Vuetify',
            completed: 7,
          }
        ],
        backend: [
          {
            id: 'csharp',
            name: 'C#',
            completed: 10,
          },
          {
            id: 'net',
            name: '.NET',
            completed: 8,
          },
          {
            id: 'php',
            name: 'PHP',
            completed: 6,
          },
        ],
        others: [
          {
            id: 'pm',
            name: 'PM, Scrum',
            completed: 9,
          },
          {
            id: 'git',
            name: 'GIT',
            completed: 8,
          },
          {
            id: 'eng',
            name: 'English',
            completed: 9,
          },
           {
            id: 'firebase',
            name: 'Firebase',
            completed: 8,
          },
          {
            id: 'seo',
            name: 'SEO',
            completed: 8,
          },
        ],
        cardsStatusShow: [false, false, false, false],
      }
    },
    watch: {
      showCards(value){
        //console.log(value);
        if(value === true){
          this.stagger();
        }
      }
    },
    methods: {
      enter(el){
        gsap.from(el, {
          duration: 1,
          opacity: 0,
          scale: 0,
          y: 200,
          ease: 'power1',
          stagger: {
            from: 'edges',
            each: 0.1
          }
        })
      },
      stagger(){
        gsap.from('.card-container', {
          duration: 1,
          delay: 0.5,
          opacity: 0,
          scale: 0,
          y: 200,
          ease: 'power1',
          stagger: {
            from: 'edges',
            each: 0.1
          }
        });
      }
    }
    
  }
 
</script>

<style scoped>
.card-item .card-front,
.card-item .card-back
{
  border-color: var(--gray-dark);
  background-color: var(--gray-dark);
  color: #fff;
}
.card-container{
  height: 320px;
}
.card-item{
  width: 260px;
  height: inherit;
  max-width: 100%;
}
.card-item.flip .card-body{
  padding: 0;
  height: 100%;
  /* flip */
  position: relative;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  /*box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);*/
}

.card-item.flip .card-front{
 /*display: flex;
  justify-content: center;
  align-items: center;*/
}
.card-item.flip .card-front, 
.card-item.flip .card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
}
.card-item.flip:hover .card-body {
  transform: rotateY(180deg);
}
.card-item.flip .card-back{
  transform: rotateY(180deg);
}
.card-item.flip .card-back .main-image{
  display: block !important;
  height: 80px;
  width: 80px;
}
.radial-progress-inner >p{
  margin-bottom: 0;
}
.radial-wrapper{
  height: inherit;
}

/* transition */
.card-item{
 transition-delay: 0s;
}
.card-back{
  background-color: #fff;
  color:#2C2B30;
}
.card-front.bicolor{
  padding: 0 !important;
  border: 1px solid #D6D6D6 !important;
}
.card-front.bicolor .title{
  margin-top: 80px;
}
.card-front.bicolor .icon-area{
  height: 120px;
  width: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.card-front.bicolor .icon-area >.circle-container{
  position: relative;
  width: 120px;
  height: 120px;
}
.card-front.bicolor .icon-area >.circle-container > .circle{
  background-color: #FFF;
      border-radius: 50%;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 46px;
    font-size: 60px;
    border: 1px solid #D6D6D6;
}

</style>